import dateTimeHelper from '../../../Helpers/datetimeHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import selectHelper from '../../../Helpers/selectHelper';
import SearchParamsBase from '../../../Elements/SearchParamsBase';
import FeeTypesEnum from '../../../Enums/FeeTypesEnum';

export default class OutsourcedFeeSearchParams extends SearchParamsBase {
  static saveType = 'OutsourcedFeeSearchParams';

  initialize() {
    this.FeeType = '';
    this.OutsourcingOfficeIds = [];
    this.FieldworkOfficeIds = [];
    this.ClientIds = [];
    this.SurveyIds = [];
    this.TpSurveyIds = [];
    this.UseDateRange = false;
    this.StartDate = dateTimeHelper.indefiniteDateValue();
    this.EndDate = dateTimeHelper.indefiniteDateValue();
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'FeeType',
      label: 'Fee Type',
      className: 'col-3',
      type: InputTypesEnum.Select,
      options: OutsourcedFeeSearchParams.getSelectValuesForFeeType(),
    },
    {
      fieldName: 'OutsourcingOfficeIds',
      label: 'Work Done By',
      className: 'col-3',
      type: InputTypesEnum.OfficeMultiSelect,
    },
    {
      fieldName: 'FieldworkOfficeIds',
      label: 'Bill To Office',
      className: 'col-3',
      type: InputTypesEnum.OfficeMultiSelect,
    },
    {
      fieldName: 'ClientIds',
      label: 'Client',
      className: 'col-3',
      type: InputTypesEnum.ClientMultiChoice,
    },
    {
      fieldName: 'SurveyIds',
      label: 'Survey',
      className: 'col-3',
      type: InputTypesEnum.SurveyMultiChoice,
    },
    {
      fieldName: 'TpSurveyIds',
      label: 'TP Survey',
      className: 'col-3',
      type: InputTypesEnum.TpSurveyMultiChoice,
    },
    {
      fieldName: 'UseDateRange',
      label: 'Use Date Range',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'StartDate',
      label: 'Start Date',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    {
      fieldName: 'EndDate',
      label: 'End Date',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
  ];

  // RM/DQ, not Resource/DataQuality — the latter are the FREELANCER fee-type labels. OutsourcedFee.FeeType
  // is CHECK-constrained to RM/KAM/BD/DQ/IT/BI/Finance/Marketing/HR, so filtering by the freelancer labels
  // matched nothing and RM/DQ could not be filtered at all. Keep in sync with the edit wizard's list.
  static getSelectValuesForFeeType() {
    return selectHelper.generateSelectValues([
      '',
      FeeTypesEnum.RM,
      FeeTypesEnum.DQ,
      FeeTypesEnum.KAM,
      FeeTypesEnum.BD,
      FeeTypesEnum.BI,
      FeeTypesEnum.IT,
      FeeTypesEnum.HR,
      FeeTypesEnum.Marketing,
      FeeTypesEnum.Finance,
    ]);
  }
}
